import React, { useState } from 'react';
import { FileText, PenSquare, Save, X } from 'lucide-react';
import { actualizarMatricula } from '../../services/matriculaService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DatosMedicos = ({ matricula }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    tipo_parto: matricula.datosMedicos?.tipo_parto || '',
    semanas_gestacion: matricula.datosMedicos?.semanas_gestacion || '',
    causa_cesarea: matricula.datosMedicos?.causa_cesarea || '',
    peso: matricula.datosMedicos?.peso || '',
    estatura: matricula.datosMedicos?.estatura || '',
    complicaciones_parto: matricula.datosMedicos?.complicaciones_parto || false,
    complicaciones_parto_detalle: matricula.datosMedicos?.complicaciones_parto_detalle || '',
    complicaciones_embarazo: matricula.datosMedicos?.complicaciones_embarazo || false,
    complicaciones_embarazo_detalle: matricula.datosMedicos?.complicaciones_embarazo_detalle || '',
    cuidados_extras: matricula.datosMedicos?.cuidados_extras || false,
    cuidados_extras_detalle: matricula.datosMedicos?.cuidados_extras_detalle || '',
    enfermedades: matricula.datosMedicos?.enfermedades || '',
    problemas_vision: matricula.datosMedicos?.problemas_vision || false,
    problemas_vision_detalle: matricula.datosMedicos?.problemas_vision_detalle || '',
    problemas_audicion: matricula.datosMedicos?.problemas_audicion || false,
    problemas_audicion_detalle: matricula.datosMedicos?.problemas_audicion_detalle || '',
    ingresos_hospitalarios: matricula.datosMedicos?.ingresos_hospitalarios || '',
    alergias: matricula.datosMedicos?.alergias || '',
    accidentes: matricula.datosMedicos?.accidentes || '',
    operaciones_quirurgicas: matricula.datosMedicos?.operaciones_quirurgicas || false,
    operaciones_quirurgicas_detalle: matricula.datosMedicos?.operaciones_quirurgicas_detalle || '',
    enfermedades_cronicas: matricula.datosMedicos?.enfermedades_cronicas || '',
    control_neurologico: matricula.datosMedicos?.control_neurologico || false,
    control_neurologico_detalle: matricula.datosMedicos?.control_neurologico_detalle || '',
    discapacidad: matricula.datosMedicos?.discapacidad || false,
    discapacidad_detalle: matricula.datosMedicos?.discapacidad_detalle || '',
    antecedentes_familiares: matricula.datosMedicos?.antecedentes_familiares || ''
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'radio' ? value === 'true' : value
    }));
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  };

  const validarForm = () => {
    const newErrors = {};
    
    if (!formData.tipo_parto) {
      newErrors.tipo_parto = 'El tipo de parto es obligatorio';
    }
    if (!formData.semanas_gestacion) {
      newErrors.semanas_gestacion = 'Las semanas de gestación son obligatorias';
    } else if (parseFloat(formData.semanas_gestacion) <= 0) {
      newErrors.semanas_gestacion = 'Las semanas de gestación deben ser un número positivo';
    } else if (!Number.isInteger(parseFloat(formData.semanas_gestacion))) {
      newErrors.semanas_gestacion = 'Las semanas de gestación deben ser un número entero';
    }
    
    if (!formData.peso) {
      newErrors.peso = 'El peso es obligatorio';
    } else if (parseFloat(formData.peso) <= 0) {
      newErrors.peso = 'El peso debe ser un número positivo';
    }

    if (!formData.estatura) {
      newErrors.estatura = 'La estatura es obligatoria';
    } else if (parseInt(formData.estatura) <= 0) {
      newErrors.estatura = 'La estatura debe ser un número entero positivo';
    } else if (!Number.isInteger(parseFloat(formData.estatura))) {
      newErrors.estatura = 'La estatura debe ser un número entero';
    }

    if (!formData.enfermedades) {
      newErrors.enfermedades = 'Las enfermedades padecidas son obligatorias. Si no hay ninguna, escriba "Ninguna"';
    }

    if (!formData.alergias) {
      newErrors.alergias = 'Las alergias son obligatorias. Si no hay ninguna, escriba "Ninguna"';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    try {
      if (!validarForm()) {
        return;
      }

      await actualizarMatricula(matricula.nino.id_child, {
        datosMedicos: formData
      });

      setIsEditing(false);
      matricula.datosMedicos = formData;
      toast.success('Datos médicos actualizados exitosamente', {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    } catch (error) {
      console.error('Error al actualizar:', error);
      toast.error('Error al actualizar los datos médicos: ' + error.message, {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
      });
    }
  };

  const inputStyle = "w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500";
  const textareaStyle = "w-full h-11 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500";
  const errorStyle = "border-red-300 focus:ring-red-500 focus:border-red-500";
  const radioStyle = "form-radio h-3 w-3 text-indigo-600 transition duration-150 ease-in-out rounded-full";

  const RadioGroup = ({ name, value, onChange }) => (
    <div className="flex items-center space-x-4">
      <label className="inline-flex items-center">
        <input
          type="radio"
          name={name}
          value="true"
          checked={value === true}
          onChange={onChange}
          className={radioStyle}
        />
        <span className="ml-2">Sí</span>
      </label>
      <label className="inline-flex items-center">
        <input
          type="radio"
          name={name}
          value="false"
          checked={value === false}
          onChange={onChange}
          className={radioStyle}
        />
        <span className="ml-2">No</span>
      </label>
    </div>
  );

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 relative">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 flex items-center">
          <FileText className="mr-2 text-indigo-500" size={20} />
          Datos Médicos
        </h3>
        {!isEditing ? (
          <PenSquare 
            className="text-indigo-500 cursor-pointer hover:text-indigo-600" 
            size={20} 
            onClick={() => setIsEditing(true)}
          />
        ) : (
          <div className="flex gap-2">
            <Save 
              className="text-green-500 cursor-pointer hover:text-green-600" 
              size={20} 
              onClick={handleSubmit}
            />
            <X 
              className="text-red-500 cursor-pointer hover:text-red-600" 
              size={20} 
              onClick={() => setIsEditing(false)}
            />
          </div>
        )}
      </div>

      <div className="space-y-4">
        {Object.entries({
          'Tipo de parto': isEditing ? (
            <div>
              <select
                name="tipo_parto"
                value={formData.tipo_parto}
                onChange={handleInputChange}
                className={`${inputStyle} ${errors.tipo_parto ? errorStyle : ''}`}
              >
                <option value="">Seleccione el tipo</option>
                <option value="Natural">Natural</option>
                <option value="Cesarea">Cesárea</option>
              </select>
              {errors.tipo_parto && 
                <p className="text-red-500 text-sm mt-1">{errors.tipo_parto}</p>
              }
            </div>
          ) : formData.tipo_parto,

          'Semanas de gestación': isEditing ? (
            <div>
              <input
                type="number"
                name="semanas_gestacion"
                value={formData.semanas_gestacion}
                onChange={handleInputChange}
                className={`${inputStyle} ${errors.semanas_gestacion ? errorStyle : ''}`}
                min="20"
                max="42"
                step="1"
                placeholder="Ingrese las semanas"
              />
              {errors.semanas_gestacion && 
                <p className="text-red-500 text-sm mt-1">{errors.semanas_gestacion}</p>
              }
            </div>
          ) : formData.semanas_gestacion,

          'Causa de la cesárea': isEditing ? (
            <input
              name="causa_cesarea"
              value={formData.causa_cesarea}
              onChange={handleInputChange}
              className={inputStyle}
              placeholder="Especifique la causa"
              disabled={formData.tipo_parto !== 'cesarea'}
            />
          ) : formData.causa_cesarea || 'Ninguna',

          'Peso': isEditing ? (
            <div>
              <input
                type="number"
                name="peso"
                value={formData.peso}
                onChange={handleInputChange}
                className={`${inputStyle} ${errors.peso ? errorStyle : ''}`}
                step="0.01"
                min="0.1"
                placeholder="Peso en kg"
                required
              />
              {errors.peso && 
                <p className="text-red-500 text-sm mt-1">{errors.peso}</p>
              }
            </div>
          ) : `${formData.peso} kg`,

          'Estatura': isEditing ? (
            <div>
              <input
                type="number"
                name="estatura"
                value={formData.estatura}
                onChange={handleInputChange}
                className={`${inputStyle} ${errors.estatura ? errorStyle : ''}`}
                min="1"
                step="1"
                placeholder="Estatura en cm"
                required
              />
              {errors.estatura && 
                <p className="text-red-500 text-sm mt-1">{errors.estatura}</p>
              }
            </div>
          ) : `${formData.estatura} cm`,

          'Complicaciones en el parto': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="complicaciones_parto"
                  value={formData.complicaciones_parto}
                  onChange={handleInputChange}
                />
              </div>
              {formData.complicaciones_parto && (
                <textarea
                  name="complicaciones_parto_detalle"
                  value={formData.complicaciones_parto_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Describa las complicaciones"
                />
              )}
            </div>
          ) : formData.complicaciones_parto ? formData.complicaciones_parto_detalle : 'Ninguna',

          'Complicaciones en el embarazo': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="complicaciones_embarazo"
                  value={formData.complicaciones_embarazo}
                  onChange={handleInputChange}
                />
              </div>
              {formData.complicaciones_embarazo && (
                <textarea
                  name="complicaciones_embarazo_detalle"
                  value={formData.complicaciones_embarazo_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Describa las complicaciones"
                />
              )}
            </div>
          ) : formData.complicaciones_embarazo ? formData.complicaciones_embarazo_detalle : 'Ninguna',

          'Cuidados especiales postparto': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="cuidados_extras"
                  value={formData.cuidados_extras}
                  onChange={handleInputChange}
                />
              </div>
              {formData.cuidados_extras && (
                <textarea
                  name="cuidados_extras_detalle"
                  value={formData.cuidados_extras_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Describa los cuidados como termo-cuna, oxigeno, etc"
                />
              )}
            </div>
          ) : formData.cuidados_extras ? formData.cuidados_extras_detalle : 'Ninguno',

          'Enfermedades padecidas': isEditing ? (
            <div>
              <textarea
                name="enfermedades"
                value={formData.enfermedades}
                onChange={handleInputChange}
                className={`${textareaStyle} ${errors.enfermedades ? errorStyle : ''}`}
                placeholder="Liste las enfermedades o escriba 'Ninguna'"
                required
              />
              {errors.enfermedades && 
                <p className="text-red-500 text-sm mt-1">{errors.enfermedades}</p>
              }
            </div>
          ) : formData.enfermedades || 'Ninguna',

          'Problemas de visión': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="problemas_vision"
                  value={formData.problemas_vision}
                  onChange={handleInputChange}
                />
              </div>
              {formData.problemas_vision && (
                <textarea
                  name="problemas_vision_detalle"
                  value={formData.problemas_vision_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Describa los problemas visuales"
                />
              )}
            </div>
          ) : formData.problemas_vision ? formData.problemas_vision_detalle : 'Ninguno',

          'Problemas de audición': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="problemas_audicion"
                  value={formData.problemas_audicion}
                  onChange={handleInputChange}
                />
              </div>
              {formData.problemas_audicion && (
                <textarea
                  name="problemas_audicion_detalle"
                  value={formData.problemas_audicion_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Describa los problemas auditivos"
                />
              )}
            </div>
          ) : formData.problemas_audicion ? formData.problemas_audicion_detalle : 'Ninguno',

          'Hospitalizaciones': isEditing ? (
            <textarea
              name="ingresos_hospitalarios"
              value={formData.ingresos_hospitalarios}
              onChange={handleInputChange}
              className={textareaStyle}
              placeholder="Liste las hospitalizaciones o escriba 'Ninguna'"
            />
          ) : formData.ingresos_hospitalarios || 'Ninguno',

          'Alergias conocidas': isEditing ? (
            <div>
              <textarea
                name="alergias"
                value={formData.alergias}
                onChange={handleInputChange}
                className={`${textareaStyle} ${errors.alergias ? errorStyle : ''}`}
                placeholder="Liste las alergias o escriba 'Ninguna'"
                required
              />
              {errors.alergias && 
                <p className="text-red-500 text-sm mt-1">{errors.alergias}</p>
              }
            </div>
          ) : formData.alergias || 'Ninguna',

          'Accidentes relevantes': isEditing ? (
            <textarea
              name="accidentes"
              value={formData.accidentes}
              onChange={handleInputChange}
              className={textareaStyle}
              placeholder="Describa los accidentes importantes"
            />
          ) : formData.accidentes || 'Ninguno',

          'Operaciones quirúrgicas': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="operaciones_quirurgicas"
                  value={formData.operaciones_quirurgicas}
                  onChange={handleInputChange}
                />
              </div>
              {formData.operaciones_quirurgicas && (
                <textarea
                  name="operaciones_quirurgicas_detalle"
                  value={formData.operaciones_quirurgicas_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Describa las operaciones"
                />
              )}
            </div>
          ) : formData.operaciones_quirurgicas ? formData.operaciones_quirurgicas_detalle : 'Ninguna',

          'Enfermedades crónicas': isEditing ? (
            <textarea
              name="enfermedades_cronicas"
              value={formData.enfermedades_cronicas}
              onChange={handleInputChange}
              className={textareaStyle}
              placeholder="Liste las enfermedades crónicas"
            />
          ) : formData.enfermedades_cronicas || 'Ninguna',

          'Control neurológico': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="control_neurologico"
                  value={formData.control_neurologico}
                  onChange={handleInputChange}
                />
              </div>
              {formData.control_neurologico && (
                <textarea
                  name="control_neurologico_detalle"
                  value={formData.control_neurologico_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Detalles del control neurológico"
                />
              )}
            </div>
          ) : formData.control_neurologico ? formData.control_neurologico_detalle : 'No',

          'Discapacidad': isEditing ? (
            <div>
              <div className="mb-2">
                <RadioGroup 
                  name="discapacidad"
                  value={formData.discapacidad}
                  onChange={handleInputChange}
                />
              </div>
              {formData.discapacidad && (
                <textarea
                  name="discapacidad_detalle"
                  value={formData.discapacidad_detalle}
                  onChange={handleInputChange}
                  className={textareaStyle}
                  placeholder="Describa la discapacidad"
                />
              )}
            </div>
          ) : formData.discapacidad ? formData.discapacidad_detalle : 'Ninguna',

          'Antecedentes familiares': isEditing ? (
            <textarea
              name="antecedentes_familiares"
              value={formData.antecedentes_familiares}
              onChange={handleInputChange}
              className={textareaStyle}
              placeholder="Liste los antecedentes familiares relevantes"
            />
          ) : formData.antecedentes_familiares || 'Ninguno'
        }).map(([label, value]) => (
          <div key={label} className="space-y-1">
            <span className="text-sm font-medium text-gray-500">{label}</span>
            <div className="text-gray-900">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DatosMedicos;
